/**
 * Product downloads functionality.
 *
 * @module feature-product-downloads
 * @version 1.0.0
 * @author Peter van Gennip, peter.van.gennip@valtech.com
 */

// const selectSpecsheet = document.querySelector('.js-download-specsheet');
const selectDownloads = document.querySelectorAll('.js-download-brochure');

/**
 * Copy value from selected option to href
 * @param {string} value value of selected option.
 * @param {Object} el select element.
 */

/* eslint-disable */
function copyValue(value, el, openModalId, modal) {
  const btn = el.nextElementSibling;


  // check if btn has class disabled, if so remove class
  if (btn.classList.contains("is-disabled")) {
    btn.classList.remove("is-disabled");
  }

  // check if value is empty, if add class
  if (value === "") {
    btn.classList.add("is-disabled");
  }

  // set modal to button if modal id is present
  if (value && !openModalId) {
    btn.setAttribute("href", value);
    btn.removeAttribute("data-toggle");
    btn.removeAttribute("data-target");
  } else if (modal) {
    btn.setAttribute("data-toggle", "modal");
    btn.setAttribute("data-target", "#"+ openModalId);
  }
}
/* eslint-enable */

/**
 * get selected option value
 */
function selectDownloadOnchange() {
  if (!selectDownloads.length) return;

  selectDownloads.forEach((download) => {
    download.addEventListener('change', (e) => {
      const el = e.target;
      const selectedString = el.options[el.selectedIndex].value;
      const openModalId = el.options[el.selectedIndex].getAttribute('data-modal');
      const modal = document.getElementById(openModalId);

      // const selectDataAttribute = el.getAttribute("data-select");

      copyValue(selectedString, el, openModalId, modal);
    });
  });
}

// On document ready
document.addEventListener('DOMContentLoaded', () => {
  selectDownloadOnchange();
});
